/*!

=========================================================
* Paper Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';

// reactstrap components

import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import config from './configuration';
import ReactGA from 'react-ga';
import queryString from 'qs';
import OpenArea from './areas/OpenArea';
import ClinicMap from './pages/ClinicMap';
import './assets/css/felix-medicus.scss';
import Middleware from './components/middlewares/Middleware';
import { Auth } from './components/context/Auth';
import { WindowManager } from './components/context/WindowManager';
import { AppInfo } from './components/context/AppInfo';
import { CookiesProvider } from 'react-cookie';
import { Tracking } from './components/context/Tracking';

const App = (props) => {
  /* React.useEffect(() => {
    ReactGA.initialize('UA-171403141-4', {
      debug: false
    });
    ReactGA.set({
      location: window.location.pathname + window.location.search
    });
    if (process.env.NODE_ENV !== 'development') ReactGA.pageview(window.location.pathname + window.location.search);
  }, []); */

  const redirectInUrl = () => {
    const params = window.location.search ? queryString.parse(window.location.search.replace('?', '')) : {};
    if (Object.keys(params).includes('goto') && window.location.origin === config.baseDomain && window.location.pathname.length <= 1) {
      if (params.goto === 'rating') {
        window.location.assign(config.baseDomain + '/open/map?goto=makeRating');
        return true;
      }
    }
    return false;
  };

  if (redirectInUrl()) {
    // Apple devices seem not to redirect otherwise
    return null;
  } else {
    return (
      <Auth>
        <CookiesProvider>
          <Tracking>
            <AppInfo>
              <WindowManager>
                <Router>
                  <Routes>
                    <Route exact path='/' element={<Navigate to={'/open/map' + window.location.search} />} />

                    <Route path='open' element={<OpenArea {...props} type='basis' ga={ReactGA} />}>
                      <Route path='map' element={<Middleware child={ClinicMap} />} />
                    </Route>

                  </Routes>
                </Router>
              </WindowManager>
            </AppInfo>
          </Tracking>
        </CookiesProvider>
      </Auth>
    );
  }
};

export default App;
